import React from "react";
import { Icon } from "@iconify/react";
import "./SocialIcons.css";

const SocialIcons = () => {
  const resumeUrl =
    "https://drive.google.com/file/d/1DnpqMI2jJbwTooYUwMlgXXur5dAt-jIH/view?usp=drive_link";

  return (
    <div className="social-icons">
      <a
        href="https://www.linkedin.com/in/yue-zheng-ting/"
        target="_blank"
        rel="noreferrer"
        className="social-icon-link"
        aria-label="LinkedIn Profile"
      >
        <Icon icon="grommet-icons:linkedin" width="28" height="28" />
      </a>
      <a
        href="https://github.com/ztdevelops/"
        target="_blank"
        rel="noreferrer"
        className="social-icon-link"
        aria-label="GitHub Profile"
      >
        <Icon icon="bi:github" width="28" height="28" />
      </a>
      <a
        href={resumeUrl}
        target="_blank"
        rel="noreferrer"
        className="social-icon-link"
        aria-label="Resume PDF"
      >
        <Icon icon="bi:file-earmark-text-fill" width="28" height="28" />
      </a>
    </div>
  );
};

export default SocialIcons;
